/**
 * @file: AiSectionHeader.tsx
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo, useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { AiTrialChip } from './AiTrialChip';

/** An AI home section's title, with its trial's chip while on one. */
export const AiSectionHeader = memo(
  ({ title, trialEndsAt }: { title: string; trialEndsAt: string | null }) => {
    const { rpx } = useResponsiveContext();
    const styles = useStyles();
    return (
      <View style={styles.header}>
        <Typography.Text bold size={rpx(16)} color={aiColors.foreground}>
          {title}
        </Typography.Text>
        {trialEndsAt != null ? <AiTrialChip trialEndsAt={trialEndsAt} /> : null}
      </View>
    );
  },
);

function useStyles() {
  const { rpx } = useResponsiveContext();
  return useMemo(
    () =>
      StyleSheet.create({
        header: {
          flexDirection: 'row',
          alignItems: 'center',
          gap: rpx(8),
          marginTop: rpx(22),
          marginBottom: rpx(12),
        },
      }),
    [rpx],
  );
}
